import { render, staticRenderFns } from "./thesis-rigistration.vue?vue&type=template&id=af706d64&"
import script from "./thesis-rigistration.vue?vue&type=script&lang=js&"
export * from "./thesis-rigistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports